import { useLanguage } from "@/context/LanguageContext";
import { Chapter, Reveal } from "@/components/atoms";

export const Tools = () => {
  const { t } = useLanguage();
  const w = t.tools;
  return (
    <section className="px-5 md:px-10 py-20 md:py-28 border-t border-hairline" data-testid="tools-section">
      <Reveal>
        <Chapter num={w.chapter} label={w.label} />
      </Reveal>
      <div className="mt-10 grid md:grid-cols-12 gap-10">
        <Reveal delay={0.1} className="md:col-span-4">
          <h2 className="font-serif font-light tracking-tight leading-tight text-3xl sm:text-4xl md:text-5xl" data-testid="tools-headline">
            {w.headline}
          </h2>
        </Reveal>
        <div className="md:col-span-8">
          <Reveal delay={0.15}>
            <ul className="flex flex-wrap gap-3" data-testid="tools-list">
              {w.list.map((tool, i) => (
                <li
                  key={i}
                  className="border border-ink/25 px-5 py-3 font-mono text-[11px] md:text-xs uppercase tracking-[0.2em] text-ink/80 transition-colors duration-300 hover:border-proof hover:text-proof"
                >
                  {tool}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
